import { render, staticRenderFns } from "./AttributeValueByIdView.vue?vue&type=template&id=6e6d176e&scoped=true"
import script from "./AttributeValueByIdView.vue?vue&type=script&lang=js"
export * from "./AttributeValueByIdView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d176e",
  null
  
)

export default component.exports